<!-- Update / merge entity (grid row present) -->
<div class="tax-attrib-entity-update-block" style="margin-left: 15px; margin-right: 15px; margin-top: 15px;">
  @if (ctx.showFormLoader) {
<div class="formLoader text-center">
    <i style="color: #e12827; font-size: 36px;" class="fa fa-spinner fa-spin"></i>
  </div>
}

  @if (!ctx.showFormLoader) {
<div class="form-horizontal">
    <div class="row" style="margin-bottom: 12px;">
      <div class="col-md-12">
        <div class="col-md-2 noWrap"><label>Entity :</label></div>
        <div class="col-md-2">
          <input type="text" class="form-control" name="entityNameUpdate" [(ngModel)]="ctx.selectedEntity" readonly>
        </div>
        <div class="col-md-2 noWrap"><label>Entity Name :</label></div>
        <div class="col-md-2">
          <input type="text" class="form-control" name="leNameUpdate" [(ngModel)]="ctx.leName" readonly>
        </div>
      </div>
    </div>

    <div class="row" style="margin-bottom: 12px;">
      <div class="col-md-12">
        <div class="col-md-2 noWrap"><label>LEID:</label></div>
        <div class="col-md-2">
          <input type="text" class="form-control" name="leidUpdate" [(ngModel)]="ctx.leid" readonly>
        </div>
        <div class="col-md-2 noWrap"><label>TAX CODE:</label></div>
        <div class="col-md-2">
          <input type="text" class="form-control" name="cdrNumberUpdate" [(ngModel)]="ctx.cdrNo" readonly>
        </div>
        <div class="col-md-2 noWrap"><label>REPORTING PERIOD:</label></div>
        <div class="col-md-2">
          <input type="text" class="form-control" name="reportingPeriodUpdate" [(ngModel)]="ctx.rp" readonly>
        </div>
      </div>
    </div>

    <div class="row" style="margin-bottom: 12px;">
      <div class="col-md-12">
        <div class="col-md-2 noWrap"><label>Posting ME:</label></div>
        <div class="col-md-2">
          <ng-container>
            <select class="form-control" name="postingMEUpdate" [(ngModel)]="ctx.selectedPostingME">
              @if (ctx.selectedPostingMEMissingFromList()) {
<option [value]="ctx.selectedPostingME">{{ ctx.selectedPostingME }}</option>
}
              @for (m of ctx.taxAttribEntityMEList; track $index) {
<option [value]="m.ME_CODE">{{ m.ME_CODE }}</option>
}
            </select>
          </ng-container>
        </div>
      </div>
    </div>

    @if (ctx.taAnnualLimit) {
<div class="row">
      <div class="col-md-12">
        <div style="padding-top: 0 !important;">
          <div id="table_container_entity_update">
            <table class="table table-bordered form-inline customTable custom-table">
              <thead>
                <tr>
                  <th>NOL Type</th>
                  <th>Schedule Start Year</th>
                  <th>Date of Acquisition per GOLD</th>
                  <th>SRLY</th>
                  <th>Override Date of Acquisition</th>
                  <th>Annual Limit</th>
                </tr>
              </thead>
              <tbody>
                @for (row of ctx.taxAttribAnnualLimitData; track $index; let idx = $index) {
<tr class="table1">
                  <td>{{ row.trans_type_desc }}</td>
                  <td>
                    <input type="text" class="form-control" [attr.name]="'schdStartYear_update_' + idx"
                           [(ngModel)]="ctx.schdStartYear"
                           (ngModelChange)="ctx.checkSchdStartYr(row)">
                  </td>
                  <td>
                    <input type="text" class="form-control" [attr.name]="'goldAcqDate_update_' + idx" [(ngModel)]="row.acqDate" readonly>
                  </td>
                  <td style="text-align: center;">
                    <input type="checkbox"
                           [(ngModel)]="row.overrideDateCheck"
                           (change)="ctx.checkAcquisitionDateNew(row)"
                           [disabled]="row.disableSrly">
                  </td>
                  <td>
                    <input type="date" class="form-control"
                           [attr.name]="'overrideDate_update_' + idx"
                           [value]="ctx.overrideDateInputValue(row)"
                           (change)="ctx.onOverrideDateChange(row, $any($event.target).value)"
                           [disabled]="row.disableOverrideDate">
                  </td>
                  <td>
                    <input class="form-control input-md numText"
                           style="text-align: right; width: 85%;"
                           type="text"
                           onlyIntegersWithLength
                           [attr.name]="'annualLimit_update_' + idx"
                           [(ngModel)]="row.amount"
                           (ngModelChange)="ctx.changedAnnualLimit(row)"
                           [disabled]="row.disableAnnualLimit">
                  </td>
                </tr>
}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
}

    @if (ctx.entityScheduleMsg) {
<div class="row">
      <div class="col-md-12">
        <span class="color-red">{{ ctx.entityScheduleMsg }}</span>
      </div>
    </div>
}
  </div>
}
</div>
